import { BaseButton, BaseButtonInterface } from 'components/atoms/button/BaseButton';
import styled from 'styled-components';
import { fontSize } from 'styles/mixins';
import { colors } from 'styles/variables';

export interface TagButtonInterface extends BaseButtonInterface {}

const TagButtonStyled = styled.span`
  display: inline-block;

  button {
    background: none;
    border: 1px solid ${colors.primary};
    border-radius: 5px;
    color: ${colors.primary};
    cursor: pointer;
    ${fontSize(12)}
    padding: 3px 10px;
    transition: background 0.3s, color 0.3s;

    &:hover {
      background: ${colors.primary};
      color: ${colors.white};
    }
  }
`

const TagButton = (props: TagButtonInterface) => (
  <TagButtonStyled>
    <BaseButton {...props} />
  </TagButtonStyled>
)

export default TagButton
